import { Badge } from "@/app/components/shadcn/badge";
import { MenuItem } from "@/app/lib/features/menus/menus.types";
import { cn } from "@/app/utils/cn";
import Link from "next/link";
import { FC } from "react";
import { trackInteraction } from "@/app/lib/tracking/interactions";

interface BottomHeaderItemProps {
  item: MenuItem;
}

const BottomHeaderItem: FC<BottomHeaderItemProps> = ({ item }) => {
  // Check if item is marked as group title (used for "new" badge)
  const isNew = item.is_new;
  
  return (
    <Link
      href={`/${item.url}`}
      onClick={() => trackInteraction("menu", item.id, "click")}
      className={cn(
        "font-medium text-sm transition-all duration-300 ease-in-out hover:text-main",
        {
          "flex items-center gap-1": isNew,
        }
      )}
    >
      <p>{item.name}</p>
      {isNew && (
        <Badge variant="destructive" size="sm">
          Yeni
        </Badge>
      )}
    </Link>
  );
};

export default BottomHeaderItem;